<template>
	<card>
		<b-row
			align-v="center"
			slot="header"
		>
			<b-col cols="8">
				<h3 class="mb-0">Editar Perfil</h3>
			</b-col>
			<b-col
				cols="4"
				class="text-right"
			>
				<a
					href="#!"
					class="btn btn-sm btn-primary"
				>Configuración</a>
			</b-col>
		</b-row>

		<b-form @submit.prevent="updateProfile">
			<h6 class="heading-small text-muted mb-4">Información Usuario</h6>

			<div class="pl-lg-4">
				<b-row>
					<b-col lg="6">
						<base-input
							type="text"
							label="Usuario"
							placeholder="Username"
							v-model="user.username"
						>
						</base-input>
					</b-col>
					<b-col lg="6">
						<base-input
							type="email"
							label="Email address"
							placeholder="mike@email.com"
							v-model="user.email"
						>
						</base-input>
					</b-col>
				</b-row>
				<b-row>
					<b-col lg="6">
						<base-input
							type="text"
							label="Nombre"
							placeholder="First Name"
							v-model="user.firstName"
						>
						</base-input>
					</b-col>
					<b-col lg="6">
						<base-input
							type="text"
							label="Apellido"
							placeholder="Last Name"
							v-model="user.lastName"
						>
						</base-input>
					</b-col>
				</b-row>
			</div>
			<hr class="my-4">

			<!-- Address -->
			<h6 class="heading-small text-muted mb-4">Contact information</h6>

			<div class="pl-lg-4">
				<b-row>
					<b-col md="12">
						<base-input
							type="text"
							label="Dirección"
							placeholder="Home Address"
							v-model="user.address"
						>
						</base-input>
					</b-col>
				</b-row>
				<b-row>
					<b-col lg="4">
						<base-input
							type="text"
							label="Ciudad"
							placeholder="City"
							v-model="user.city"
						>
						</base-input>
					</b-col>
					<b-col lg="4">
						<base-input
							type="text"
							label="Pais"
							placeholder="Country"
							v-model="user.country"
						>
						</base-input>
					</b-col>
					<b-col lg="4">
						<base-input
							label="Codigo Postal"
							placeholder="ZIP Code"
							v-model="user.postalCode"
						>
						</base-input>
					</b-col>
				</b-row>
			</div>

			<hr class="my-4">
			<!-- Description -->
			<h6 class="heading-small text-muted mb-4">Acerca de Mi</h6>
			<div class="pl-lg-4">
				<b-form-group
					label="Acerca de Mi"
					label-class="form-control-label"
					class="mb-0"
					label-for="about-form-textaria"
				>
					<!--  <label class="form-control-label">About Me</label> -->
					<b-form-textarea
						rows="4"
						value="Escribe aqui una breve reseña de ti!"
						id="about-form-textaria"
						placeholder="Un poco de ti ..."
					></b-form-textarea>
				</b-form-group>
			</div>

		</b-form>
	</card>
</template>
<script>
export default {
	data() {
		return {
			user: {
				company: 'Banco de Guayaquil',
				username: 'Oficial1',
				email: '',
				firstName: 'Banco',
				lastName: 'Guayaquil',
				address: 'Quito, av 1234',
				city: 'Quito',
				country: 'Ecuador',
				postalCode: '',
				aboutMe: `Entidad Financiera`
			}
		};
	},
	methods: {
		updateProfile() {
			alert('Your data: ' + JSON.stringify(this.user));
		}
	}
};
</script>
<style></style>
